import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=664d4865&scoped=true"
import script from "./quill.vue?vue&type=script&lang=js"
export * from "./quill.vue?vue&type=script&lang=js"
import style0 from "./quill.vue?vue&type=style&index=0&id=664d4865&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d4865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664d4865')) {
      api.createRecord('664d4865', component.options)
    } else {
      api.reload('664d4865', component.options)
    }
    module.hot.accept("./quill.vue?vue&type=template&id=664d4865&scoped=true", function () {
      api.rerender('664d4865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WeforsysEditor/quill.vue"
export default component.exports